let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iF3UX")).then(() => parcelRequire('cT4vo'));